import React, { useState, useEffect } from 'react';
import {
    DataTable, TableContainer, Table, TableHead, TableRow, TableHeader, TableBody, TableCell, TableToolbar, TableToolbarContent,
    StructuredListWrapper, StructuredListHead, StructuredListRow, StructuredListCell, StructuredListBody, Pagination
} from 'carbon-components-react';

import { ReactComponent as SquareFill } from 'assets/image/square-fill.svg';
import * as DashboardConstants from '.././DashboardConstants';
import './BotPerformance.scss';

export default function TableComponent(props) {
    const [totalItems, setTotalItems] = useState(0);
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const defaultFirstRowIndex = 0;
    const defaultCurrentPageSize = props.defaultCurrentPageSize || 5;

    useEffect(() => {
        if (props.rows.length) {
            setTotalItems(props.rows.length);
            getPaginatedRow(defaultFirstRowIndex, defaultCurrentPageSize);
        }
    }, [props.rows]);

    function getPaginatedRow(param, pageSize) {
        let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
        let slicedRows = props.rows.slice(startingIndex, startingIndex + pageSize);
        setPaginatedRows(slicedRows);
    }

    return (
        props.rows.length && !props.loading ?
            <div className="firstTimeRun-table">
                <div style={{ border: "1px solid #E0E0E0" }}>
                    <DataTable
                        style={{ padding: 0 }}
                        rows={paginatedRows}
                        headers={props.headers}
                        isSortable={false}
                        render={({
                            rows,
                            headers,
                            getHeaderProps,
                            getRowProps,
                            getTableProps,
                            getToolbarProps,
                            getTableContainerProps,
                        }) => (
                            <TableContainer {...getTableContainerProps}>
                                <TableToolbar {...getToolbarProps} aria-label="data table toolbar">
                                    <TableToolbarContent style={{ clipPath: 'none', zIndex: 1 }}>
                                        <StructuredListWrapper ariaLabel="Structured list">
                                            <StructuredListHead>
                                                <StructuredListRow
                                                    head
                                                    tabIndex={0}
                                                >
                                                    <StructuredListCell head>
                                                        <div className="range-header"><SquareFill fill='#FA6400' width='12px' height='12px' /> <span className="range">1%-25%</span></div>
                                                    </StructuredListCell>
                                                    <StructuredListCell head>
                                                        <div className="range-header"><SquareFill fill='#F7B500' width='12px' height='12px' /> <span className="range">25.01%-50%</span></div>
                                                    </StructuredListCell>
                                                    <StructuredListCell head>
                                                        <div className="range-header"><SquareFill fill='#0091FF' width='12px' height='12px' /><span className="range"> 50.01%-80%</span></div>
                                                    </StructuredListCell>
                                                    <StructuredListCell head>
                                                        <div className="range-header"><SquareFill fill='#32C5FF' width='12px' height='12px' /> <span className="range">80.01%-95%</span></div>
                                                    </StructuredListCell>
                                                    <StructuredListCell head>
                                                        <div className="range-header"><SquareFill fill='#44D7B6' width='12px' height='12px' /> <span className="range">95.01%-99.9%</span></div>
                                                    </StructuredListCell>
                                                    <StructuredListCell head>
                                                        <div className="range-header"><SquareFill fill='#6DD400' width='12px' height='12px' /> <span className="range">100%</span></div>
                                                    </StructuredListCell>
                                                    <StructuredListCell head>
                                                        <div className="range-header"><SquareFill fill='#E02020' width='12px' height='12px' /> <span className="range">0</span></div>
                                                    </StructuredListCell>
                                                </StructuredListRow>
                                            </StructuredListHead>
                                            <StructuredListBody>
                                                <StructuredListRow tabIndex={0}>
                                                    <StructuredListCell>{props.botsCount.range1}</StructuredListCell>
                                                    <StructuredListCell>{props.botsCount.range2}</StructuredListCell>
                                                    <StructuredListCell>{props.botsCount.range3}</StructuredListCell>
                                                    <StructuredListCell>{props.botsCount.range4}</StructuredListCell>
                                                    <StructuredListCell>{props.botsCount.range5}</StructuredListCell>
                                                    <StructuredListCell>{props.botsCount.range6}</StructuredListCell>
                                                    <StructuredListCell>{props.botsCount.range7}</StructuredListCell>
                                                </StructuredListRow>
                                            </StructuredListBody>
                                        </StructuredListWrapper>
                                    </TableToolbarContent>
                                </TableToolbar>
                                <Table {...getTableProps()}>
                                    <TableHead style={{ borderTop: '1.75px solid #000000' }}>
                                        <TableRow>
                                            {headers.map((header, i) => (
                                                <TableHeader key={i} {...getHeaderProps({ header })}> {header.header}</TableHeader>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <TableRow {...getRowProps({ row })}>
                                                {row.cells.map((cell) => (
                                                    <TableCell key={cell.id}>{cell.value}</TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    />
                </div>
                {
                    props.rows.length > 5 &&
                    <Pagination
                        totalItems={totalItems}
                        style={{ border: '1px solid #E0E0E0', width: '100%!important' }}
                        backwardText={DashboardConstants.Previouspage}
                        forwardText={DashboardConstants.NextPage}
                        pageSize={props.defaultCurrentPageSize || 5}
                        pageSizes={[5, 10, 15, 25]}
                        itemsPerPageText={DashboardConstants.Itemspage}
                        onChange={({ page, pageSize }) => {
                            let newFirstRowIndex = pageSize * (page - 1);
                            setFirstRowIndex(newFirstRowIndex)
                            getPaginatedRow(newFirstRowIndex, pageSize);
                        }}
                    />
                }
            </div>
            : <div className="message"></div>
    )
}